import {customerIdSelector} from "components/Admin/atoms/customer";
import {useRecoilValue} from "recoil";

export default function GetCustomerId({children}) {
    const customerId = useRecoilValue(customerIdSelector);

    return children(customerId);
}
